import React from 'react';
import { t } from '@lingui/core/macro';

import { SearchParamsPetType } from '@rover/constants/src/translations/sitterProfilePage.constants';
import { Flex } from '@rover/kibble/core';
import { Badge } from '@rover/kibble/official-patterns/Badge';
import { useApiBrightHorizonsSitterProfileBannerRetrieve } from '@rover/rsdk/src/apiClient/latest/api-bright-horizons-sitter-profile-banner-retrieve';

import { useRevampCta } from '../../hooks/useRevampCta';
import { BHSitterProfileBanner } from '../BHSitterProfileBanner/BHSitterProfileBanner';
import PromoteProfileButton from '../PromoteProfileButton/PromoteProfileButton';

import EditProfileButton from './EditProfileButton';
import RevampMobileCtaBarCommon from './RevampMobileCtaCommon';
import RevampMobileCtaPtBannerCommon from './RevampMobileCtaPtBannerCommon';
import RevampNotApprovedCta from './RevampNotApprovedCta';
import { CTAProps } from './RevampServicesCta';
import { getSitterSlugFromWebUrl } from './utils';

type Props = {
  handleOpenSheet: () => void;
};

const RevampMobileCtaBarSelfView = ({
  handleOpenSheet,
  priceTransparencyLevel,
  locale,
  petCount,
  petType,
  bookingFeePercentage,
  isApproved,
}: Props & CTAProps): JSX.Element => {
  const { sitterData, serviceType, isBrightHorizonsUser } = useRevampCta();

  const { data: brightHorizonsBanner } = useApiBrightHorizonsSitterProfileBannerRetrieve(
    {
      serviceType: serviceType || 'boarding',
      slug: getSitterSlugFromWebUrl(sitterData.webUrl),
      petType: petType || SearchParamsPetType.DOG_CAT,
      dogCount: petCount.selectedDogCount,
      catCount: petCount.selectedCatCount,
      puppyCount: petCount.selectedPuppyCount,
    },
    {
      query: {
        enabled: isBrightHorizonsUser,
      },
    }
  );

  const approvedCTA = (
    <>
      <Badge
        text={t`Your public profile`}
        variant="callout"
        boxProps={{
          testID: 'revamp-mobile-self-view-badge',
          alignSelf: 'flex-start',
          mb: '3x',
          px: '2x',
          py: '0x',
        }}
      />
      <Flex justifyContent="space-between" alignItems="center" pb="3x" pt="4x">
        <RevampMobileCtaBarCommon
          handleOpenSheet={handleOpenSheet}
          priceTransparencyLevel={priceTransparencyLevel}
          locale={locale}
          petCount={petCount}
          petType={petType}
        />
      </Flex>

      <RevampMobileCtaPtBannerCommon
        priceTransparencyLevel={priceTransparencyLevel}
        petCount={petCount}
        petType={petType}
        bookingFeePercentage={bookingFeePercentage}
      />

      <BHSitterProfileBanner brightHorizonsBanner={brightHorizonsBanner} />

      <Flex flexDirection="column" gap="4x" pt="2x" pb="3x">
        <PromoteProfileButton fullWidth isRevampLayout />
        <EditProfileButton fullWidth serviceType={serviceType} />
      </Flex>
    </>
  );

  return isApproved ? approvedCTA : <RevampNotApprovedCta />;
};

export default RevampMobileCtaBarSelfView;
